module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2NVHn"))).then(() => parcelRequire('8rm4T'));